import {formReducer, modelReducer, actions as formActions} from 'react-redux-form';
import {combineReducers} from 'redux';
import {actions as customerActions} from '../ducks/customer';

const actionType = (action) => `schooladmin/mmsSettings/${action}`;

const types = {
  LOAD: actionType('LOAD'),
  SET_API_HEALTH: actionType('SET_API_HEALTH')
};

// Action creators

const checkApiHealth = () => (dispatch) => {
  fetch('https://gpkpyklzq55q.statuspage.io/api/v2/components.json')
    .then((response) =>
      response.json().then(json => {
        const api = json.components.find((c) => c.name === 'SMS');
        let status;

        switch (api.status) {
          case 'major_outage':
            status = 'down';
            break;
          case 'degraded_performance':
          case 'partial_outage':
            status = 'degraded';
            break;
          default:
            status = 'up';
        }

        return dispatch({type: types.SET_API_HEALTH, apiHealth: status});
      })
    )
    .catch(() => dispatch({type: types.SET_API_HEALTH, apiHealth: 'down'}));
};

const load = (model) => (dispatch) => {
  dispatch({type: types.LOAD});
  return dispatch(formActions.load('mmsSettings.model', model));
};

const save = (model) => (dispatch) => {
  return dispatch(customerActions.save(model));
};

// Reducers

const getHealth = (state = '', action) => {
  switch (action.type) {
    case types.SET_API_HEALTH:
      return action.apiHealth;
    default:
      return state;
  }
};

const reducer = combineReducers({
  apiHealth: getHealth,
  model: modelReducer('mmsSettings.model'),
  form: formReducer('mmsSettings.model')
});

export default reducer;

export const actions = {
  checkApiHealth,
  load,
  save
};
